import { render, staticRenderFns } from "./OnboardingLocation.vue?vue&type=template&id=5e9c392c&"
import script from "./OnboardingLocation.vue?vue&type=script&lang=js&"
export * from "./OnboardingLocation.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingLocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports